import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { fadeUp } from '../../utils/motion';
export type LinkListItem = {
  title: string;
  description?: string;
  href: string;
};
type LinkListProps = {
  items: LinkListItem[];
  columns?: 2 | 3;
  label: string;
};
const columnClasses = {
  2: 'md:grid-cols-2',
  3: 'md:grid-cols-2 lg:grid-cols-3'
};
export function LinkList({
  items,
  columns = 3,
  label
}: LinkListProps) {
  return <motion.ul {...fadeUp} aria-label={label} className={`grid grid-cols-1 ${columnClasses[columns]} gap-x-10 border-t border-line`} data-id="element-555" data-mp="1ndsak24fjd3z">
      {items.map(item => <li key={item.href} className="border-b border-line" data-id="element-556" data-mp="1dfci9vto1xsw">
          <a href={item.href} className="group flex h-full items-start gap-4 py-6" data-id="element-557" data-mp="1id4bct61rpyo">
            <span className="flex-1" data-id="element-558" data-mp="37r10q7z3wii1">
              <span className="block font-heading font-bold text-lg text-ink-dark group-hover:text-navy transition-colors duration-150" data-id="element-559" data-mp="37s2isweji599">
                {item.title}
              </span>
              {item.description && <span className="mt-1.5 block text-ink-muted leading-relaxed" data-id="element-560" data-mp="3rdtkx8spal8z">{item.description}</span>}
            </span>
            <ArrowRight size={18} aria-hidden="true" className="mt-1 shrink-0 text-teal transition-transform duration-150 ease-out group-hover:translate-x-1" data-id="element-561" data-mp="9wadrqcbaev7" />
          </a>
        </li>)}
    </motion.ul>;
}